<template>
  <div class="errorview">
    <div class="errorview-bg">
      <div class="signOut" slot="body" @click="signOut">
        <i class="icon icon--signout"></i>
        <span>{{ $t('Web.Profile.Buttons.Logout') }}</span>
      </div>
      <img src="../../assets/img/ico-error-big.svg" alt="error icon" />
    </div>
    <div class="errorview-content">
      <div class="content error">
        <h1>{{ $t('Web.Errors.Fatal.Device.Title') }}</h1>
        <p>{{ $t('Web.Errors.Fatal.Device.Message') }}</p>
        <ServicePerson class="cmp"></ServicePerson>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ServicePerson from './../_common/servicePerson';

export default {
  name: 'PageDeviceError',
  data() {
    return {
      error: false
    };
  },
  components: {
    ServicePerson
  },
  methods: {
    signOut() {
      this.$Amplify.Auth.signOut().then(() => {
        // reset device state
        this.$store.dispatch('clearDevices');

        //reset cactursProfile state
        this.$store.dispatch('resetState');

        // ensure that our application is in a valid and functioning state after logout
        location.reload();
      });
    }
  },
  computed: {
    ...mapGetters(['deviceList', 'device'])
  }
};
</script>

<style lang="scss" scoped>
.errorview {
  padding-top: 160px;
}

.signOut {
  position: absolute;
  top: 20px;
  left: 10px;
  white-space: nowrap;
  text-align: center;
  cursor: pointer;

  .icon--signout {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url('../../assets/img/ico-header-back.svg') no-repeat center center;
  }

  span {
    @include textSmall;
    display: block;
    color: $greeny-blue;
    height: 24px;
  }
}

.errorview-bg {
  background: $charcoal-grey url('../../assets/img/img-battery-big-no-bg.svg') no-repeat center 56px;
  position: fixed;
  height: 160px;
  top: 0;
  width: 100%;
  z-index: 1;

  img {
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -53px;
    z-index: 5;
  }
}

.errorview-content {
  background: $white;
  position: relative;
  height: 100%;
}

.content {
  margin: -52px auto 40px auto;
  max-width: $maxWidth;
  text-align: center;
  background: $white;
  position: relative;
  padding-top: 50px;
}

h1 {
  @include headlineApp;
  text-align: center;
  margin: 15px 0 12px 0;
  font-weight: normal;
}

p {
  font-size: 13px;
  line-height: 1.38;
  color: $charcoal-grey;
  font-family: 'SiemensSansGlobalCC-Roman', 'Helvetica Neue', Helvetica, sans-serif;
}

.btn {
  display: block;
  margin-top: 60px;
  border-radius: 8px;
  background-color: $greeny-blue;
  border: none;
  color: $white;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
}

a {
  font-size: 14px;
  color: $greeny-blue;
  margin-top: 40px;
  display: block;
}

.cmp {
  text-align: left;
}

.error {
  &:before {
    display: none;
  }

  h1,
  p {
    color: $orange;
  }

  p {
    margin-bottom: 24px;
  }
}
</style>
